// extracted by mini-css-extract-plugin
module.exports = {"cityPage":"styles-module--cityPage--3U6Gy"};